<template>
      <div class="publicViewClass" style="padding-top:0">
           <div class="edit-step">
            <topicSteps :active = "3" :propList="propList"></topicSteps>
        </div>
          <div id="editPaper" class="app-inner">
                <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            上一步
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="SavePush"
            >
             完成
           </el-button>
            </div>
                       <!-- 试卷设置 -->
            <div class="setting-content">
                 <div class="list-box">
                        <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">有效期限</p>
                        </div>
                        <div class="settings-box-radio flex">
                            <span class="settings-box-radio-tit">当前：</span>
                             <div class="right-div" :style="list.validPeriod == '1' ? {'marginTop':'-10px'} : ''">
                                     <div class="flex align-cen" style="padding-bottom:10px">
                                            <el-radio v-model="list.validPeriod" label="1">试卷开放时间</el-radio>
                                            <el-date-picker
                                                v-model="value1"
                                                type="datetimerange"
                                                range-separator="至"
                                                start-placeholder="开始时间"
                                                end-placeholder="结束时间"
                                                format="yyyy-MM-dd HH:mm:ss"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                :picker-options="pickerOptions2"
                                                @change="classSelect1"
                                                v-if="list.validPeriod == '1'"
                                                >
                                                </el-date-picker>
                                        </div>
                                <div style="margin-bottom:10px">
                                    <el-radio v-model="list.validPeriod" label="2">永久有效</el-radio>
                                </div>
                                <div>
                                     <el-radio v-model="list.validPeriod" label="0">不可用</el-radio>
                                </div>
                               
                             </div>
                        </div>
                    </div>
                       <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">练习设置</p>
                        </div>
                        <div class="settings-box-radio flex align-cen">
                            <span class="settings-box-radio-tit">是否开放练习模式：</span>
                             <el-radio v-model="list.practiceMode" label="1">开启练习模式</el-radio>
                             <el-radio v-model="list.practiceMode" label="0">不开启练习模式</el-radio>
                        </div>
                    </div>
                       <div class="settings-box" v-if="list.practiceMode == 1">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">练习时间控制</p>
                        </div>
                          <div class="settings-box-radio settings-box-radio1">
                             <span class="" >练习答卷时长:</span>
                            <el-input  placeholder="请输入内容" v-model="list.practiceTimeLimit" clearable maxlength="3"  @input="numValid('practiceTimeLimit')" class="setting-default-input"></el-input>
                             <span>分钟</span>
                        </div>
                      <div class="settings-box-radio settings-box-radio1">
                             <span class="" >最短交卷时间:</span>
                            <el-input  placeholder="请输入内容" v-model="list.practiceMinTime" clearable maxlength="3"  @input="numValid('practiceMinTime')" class="setting-default-input"></el-input>
                             <span>分钟</span>
                             <span class="hint">
                                    (留空表示不限时间。)
                                </span>
                        </div>
                    </div>
                       <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">答卷次数</p>
                        </div>
                        <div class="settings-box-radio">
                           <div class="botRadio">
                              <el-radio v-model="list.answerNumType" label="0"> 
                                无限次
                                </el-radio>
                           </div>
                            <div class="botRadio">
                              <el-radio v-model="list.answerNumType" label="1"> 
                                一次 
                                </el-radio>
                           </div>
                            <div class="botRadio flex align-cen settings-box-radio1">
                              <el-radio v-model="list.answerNumType" label="2">
                                 多次 
                                 <el-input  placeholder="请输入内容" v-model="list.answerNum" clearable maxlength="3" class="setting-default-input" v-if="list.answerNumType == 2"></el-input>
                                <span v-if="list.answerNumType == 2"> 次</span>
                                </el-radio>
                           </div>
                            <div class="botRadio">
                              <el-radio v-model="list.answerNumType" label="3">
                                每天每人
                                 <el-input  placeholder="请输入内容" v-model="list.answerNum" clearable maxlength="3" class="setting-default-input" v-if="list.answerNumType == 3"></el-input>
                                <span v-if="list.answerNumType == 3">次</span>
                                </el-radio>
                           </div>
                        </div>
                    </div>
                                     <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">答题时间控制</p>
                        </div>
                        <div class="settings-box-radio settings-box-radio1">
                             <el-radio v-model="list.answerTimeControl" label="1">
                                独立时间
                                <span class="set-exam-time">答卷时长:</span>
                                <el-input  placeholder="请输入内容" v-model="list.answerTimeLimit" clearable maxlength="3"
                                @input="numValid('answerTimeLimit')"
                                 class="setting-default-input"></el-input>
                                <span>分钟</span>
                                <span class="hint">
                                    (在规定的开放时间内，考生无论何时进入答题，都不影响答卷时长，且设置为0表示不限时长。)
                                </span>
                             </el-radio>
                        </div>
                          <div class="settings-box-radio settings-box-radio1">
                            <div class="hiddenrading" v-if="list.validPeriod == '2' || (list.validPeriod == '1' && timeDt)" @click="hiddenrading"></div>
                             <el-radio v-model="list.answerTimeControl" label="2">
                                动态时间
                                <span class="hint">
                                    (动态时间对答题时长有影响 ，考生越晚进入答题，剩余的时长越短；如设置为下午1点到3点，当考生2点进入考试，则只剩下1个小时答题时长。)
                                </span>
                             </el-radio>
                        </div>
                        <div class="settings-box-radio settings-box-radio1">
                             <span class="" >最短交卷时间:</span>
                            <el-input  placeholder="请输入内容" v-model="list.minTakenTime" clearable maxlength="3" 
                            @input="numValid('minTakenTime')"
                            class="setting-default-input"></el-input>
                             <span>分钟</span>
                             <span class="hint">
                                    (留空表示不限时间。)
                                </span>
                        </div>
                    </div>
                                           <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">登录考试方式</p>
                        </div>
                          <div class="settings-box-radio">
                            <el-radio v-model="list.authentication" label="1">
                                账号登录考试
                                 <el-tooltip class="item" effect="dark" content="考试时会要求考生输入账号和密码，验证成功后方可以考试，当您试卷类型选择为仿真系统时，改试卷会在HeroSim中与仿真平台进行绑定。且仅能够选择具有该仿真系统权限的考生。" placement="right">
                                <span class="icon-al-question-circle"></span>
                                 </el-tooltip>
                             </el-radio>
                          </div>
                             <div class="settings-box-check form-check">
                                <el-checkbox v-model="checked">
                                    指定组考试 <span>(已选{{dynamicTags1.length || '0'}}个考生组)</span>
                                </el-checkbox>
                                <div v-if="checked">
                                  <div class="tagsinput">
                                    <div class="classItem">
                                        <el-tag
                                            :key="tag.id"
                                            v-for="tag in dynamicTags1"
                                            closable
                                            :disable-transitions="false"
                                            @close="handleClose(tag,1)">
                                            {{tag.name || tag.allocateName}}
                                            </el-tag>
                                        </div>
                                </div>
                                <div class="select-stu" @click="openStu(1)">选择分组</div>
                                </div>
                             </div>
                                 <div class="settings-box-check form-check">
                                <el-checkbox v-model="checked1">
                                    指定考生考试 <span>(已选{{dynamicTags2.length || '0'}}个考生)</span>
                                </el-checkbox>
                                <div v-if="checked1">
                                  <div class="tagsinput">
                                    <div class="classItem">
                                        <el-tag
                                            :key="tag.id"
                                            v-for="tag in dynamicTags2"
                                            closable
                                            :disable-transitions="false"
                                            @close="handleClose(tag,2,tag)">
                                            {{tag.userName || tag.allocateName}}
                                            </el-tag>
                                        </div>
                                </div>
                                <div class="select-stu" @click="openStu(2)">选择考生</div>
                                </div>
                             </div>
                       </div>
                    <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">消息通知设置</p>
                        </div>
                        <div class="settings-box-radio">
                            <div class="botRadio flex align-cen" style="margin-bottom:16px">
                                <span class="notify-label">考试通知</span>
                                <el-switch v-model="list.assessAlert" active-value="1" inactive-value="0"></el-switch>
                            </div>
                            <div class="botRadio flex align-cen">
                                <span class="notify-label">考试结果通知</span>
                                <el-switch v-model="list.scoreAlert" active-value="1" inactive-value="0"></el-switch>
                            </div>
                        </div>
                    </div>
                                         <div class="settings-box">
                         <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">评语设置</p>
                        </div>
                          <div class="settings-box-radio settings-box-radio1">
                                <span class="set-exam-time">及格分数:</span>
                                <el-input  placeholder="请输入内容" v-model="list.passmark" clearable maxlength="3"
                                @input="numValid('passmark')"
                                 class="setting-default-input"></el-input>
                                <span>
                                    %
                                </span>
                        </div>
                         <div class="settings-box-radio settings-box-radio1">
                              <el-radio v-model="list.commentSet" label="1">及格评语 </el-radio>
                             <el-radio v-model="list.commentSet" label="2">分数段评语</el-radio>
                         </div>
                         <!-- 固定分数 -->
                         <div class="settings-box-radio" v-if="list.commentSet == 1">
                               <div class="AppContent">
                                <div class="moreCanvas"
                                    v-for="(item,index) in commentList"
                                    :key="index"
                                    :id="'addCanvas'+index"
                                    style="margin-bottom:20px"
                                    >
                                        <div class="public-tit flex align-cen" style="margin-bottom:20px">
                                        <div class="public-tit-list">
                                            <i class="icon-al-database-fill"></i>
                                            {{index == 0 ? '及格评语：' : '不及格评语：'}}
                                        </div>
                                    </div>
                                    <el-input
                                        type="textarea"
                                        placeholder="请输入内容"
                                        v-model="item.comments"
                                        maxlength="100"
                                        show-word-limit
                                        rows="10"
                                        >
                                        </el-input>
                                </div>
                            </div>
                         </div>
                         <!-- 分数段 -->
                          <div class="settings-box-radio" v-if="list.commentSet == 2">
                            <div class="form-group">
                                <div class="slider-comments" @mouseleave="isAmdh = false">
                                    <div class="slider-wrap" >
                                        <div class="score-slider"  ref="myDiv"   
                                          @mouseover="showWidth"
                                        >
                                            <span class="min">0%</span>
                                            <span class="max">100%</span>
                                        </div>
                                        <p></p>
                                        <div class="handle-hint bounce-transition" :data-title='`在分数${boxWidthPercent}%处插入分数段`'
                                        :style="{left:width + 'px',display:isAmdh ? 'block' : 'none'}"
                                        @click="insertNum"
                                        >
                                        </div>
                                        <div class="slider-handle bounce-transition" 
                                        v-for="(item,index) in slideClik" 
                                        :data-value='`${item}`'
                                        :style="{left:item + '%'}"
                                         @click="cacelInser(item,index)"
                                        >

                                        </div>
                                    </div>
                                </div> 
                            </div>
                             <div class="AppContent" style="margin-top:20px">
                                  <div class="moreCanvas"
                                    v-for="(item,index) in resultList"
                                    :key="index"
                                    :id="'addCanvas'+index"
                                    >
                                        <div class="public-tit flex align-cen" style="margin-bottom:20px">
                                        <div class="public-tit-list">
                                            <i class="icon-al-database-fill"></i>
                                            分数段：{{item.segment}}(单位：%)
                                        </div>
                                    <div class="mft public-btn-small" v-if="index!=0" @click="cacelInser(item,index,'tem')">
                                        <div class="public-btn-small-primary" >
                                            删除     
                                        </div>
                                    </div>
                                    </div>
                                 <el-input
                                        type="textarea"
                                        placeholder="请输入内容"
                                        v-model="item.comments"
                                        maxlength="100"
                                        show-word-limit
                                        rows="10"
                                        >
                                        </el-input>
                                </div>
                             </div>
                          </div>
                     </div>
                 </div>
            </div>
          </div>
                                     <!-- 打开学生组 -->
      <el-dialog
  title="选择分组"
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible"
  >
    <div class="forminfo">
          <el-alert
            title="当勾选分组后，其分组下学员都可以考试"
            type="warning"
            :closable="false"
             show-icon
            >
        </el-alert>
         <div class="form-check">
        <el-checkbox-group v-model="studentCheck">
            <el-checkbox v-for="(item,index) in studentClass"   :label="item.id" >
               <div class="jstree-node flex align-cen">
                <i class="jstree-icon"></i>
                <span class="jstree-name">{{item.name}}</span>
                </div> 
             </el-checkbox>
            </el-checkbox-group >
        </div>
        <div class="authbtn flex align-cen">
        <el-button plain @click="centerDialogVisible = false"> 取消</el-button>
              <el-button type="primary" @click.stop="putCheck(1)">选择</el-button>
    </div>
    </div>
      </el-dialog>
       <!-- 打开学生列表 -->
      <el-dialog
  title="选择考生"
  :visible.sync="centerDialogVisible1"
  width="60%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible1"
  >
  <div class="forminfo">
        <studentTemplate
          :authType='1'
    ref="studentTemplate"
     @sendStatus="stclassSelect"
        ></studentTemplate>
         <div class="authbtn flex align-cen">
        <el-button plain @click="centerDialogVisible1 = false"> 取消</el-button>
              <el-button type="primary" @click.stop="putCheck(2)">选择</el-button>
    </div>
  </div>
      </el-dialog>
    </div>
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import quillTemplate from "@/components/quill/index.vue"; //单富文本组件
import quillsTemplate from "@/components/quills";  //多富文本组件
import  studentTemplate from "@/weteacheManage/member/studentList/index.vue"; //将题目分类页面作为组件使用
import {editEmuPaper,EmuPaperDetail,getemuComments,fzAllocateList,getAllStudentClass,getStudentList} from "@/api/enterprise/index"   //修改试卷、查询仿真试卷详情、评分列表
export default {
    name:'endRaso',
      components: {
        topicSteps,
        quillsTemplate,
        quillTemplate,
        studentTemplate
    },
    data() {
        return {
             swichId:'',
            swichIndex:'',
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            swichList:[],
            errorDataChecked:[],
             checkAll1:false,
            textActive:-1,
            searchName:'',
            dynamicTags1:[],
            dynamicTags2:[],
            studentClass:[],
            studentCheck:[],
            businessInfo:{},
            centerDialogVisible:false,
            centerDialogVisible1:false,
            timeDt:false,
                 pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },      
                value1:[],

                 resultList:[
              {
                    "segment":'0-100',
                    "comments":''
                }
            ],
            slideClik:[],
            isAmdh:true,
             width:323.5,
                commentList:[
                {
                    "segment":'60-100',
                    "comments":''
                },{
                   "segment":'0-59',
                   "comments":'' 
                }
               ],
            isAutoSkip:true,
            list:{},
         allocateList:[],
         checked:false,
         checked1:false,
         classifyId:'',
             loading:false,
             propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'配置步骤',
            },{
                steps:3,
                text:'试卷设置',
            },{
                steps:4,
                text:'完成', 
            }

        ],
        }
    },
      computed: {  
    boxWidthPercent() {  
    let num = Math.round((this.width / 647) * 100) < 100 ? Math.round((this.width / 647) * 100) : 100
    return num;   
    }  
  },
    created () {
         this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getPaperDetail() 
         this.studetChFun(1)
     this.studetChFun(2)
    },
    methods: {
          stclassSelect(val,val1){
            // console.log(val)
            this.dynamicTags2 = val
        },
            studetChFun(type){
        fzAllocateList({id:this.$route.query.threeId,type:type})
        .then(res =>{ 
            // console.log(res.data)
           this['dynamicTags' + type] = res.data || []
           if(type == 1 && this.dynamicTags1.length) this.checked = true
            if(type == 2 && this.dynamicTags2.length) this.checked1= true

        })
        },
          // 打开学生组
        openStu(type){
           if(type == 1){
             this.centerDialogVisible = true
            this.getclass(1)
           }
           if(type == 2){
            this.centerDialogVisible1 = true
            this.$nextTick(function () {   
                 this.$refs.studentTemplate.steditfun(this.dynamicTags2)    
             })
           }
        },
           getclass(type){
            this.studentCheck = []
            getAllStudentClass({businessId:this.businessInfo.id,name:this.searchName})
            .then(res =>{
                this.studentClass = res.data
                if(this.dynamicTags1.length){
                   for (let key in this.dynamicTags1) {
                    this.studentCheck.push((this.dynamicTags1[key].businessId ? this.dynamicTags1[key].id : this.dynamicTags1[key].allocateId)) 
                   }
                    
                }

            })
        },
               // 手动选择
        getopicPage(){
            let params = {
                 businessId:this.businessInfo.id,
                size:this.PageSize,
                current:this.currentPage,
                classifyId:this.classifyId
            }
             getStudentList(params,'enterprise')
                .then(res => {
                 this.swichList  = res.data.records
                this.totalCount = res.data.total
                })
          .catch(err => {})
        },
            // 标签移除
        handleClose(tag,type){
           this['dynamicTags' + type].splice(this['dynamicTags' + type].indexOf(tag), 1);
            if(type == 1) {
                this.studentCheck = this.studentCheck.filter(item => this.dynamicTags1.some(ele=>ele.id===item))
            }
        },
               // 选择学生组
        putCheck(type){
            if(type == 1){
                if(!this.studentCheck.length) return this.$util.Notifi('请先勾选','error','fa-exclamation-circle')
                
                    this.dynamicTags1 = this.studentClass.filter(item => this.studentCheck.some(ele=>ele===item.id))
                this.centerDialogVisible = false
            }
            if(type == 2){
                if(!this.dynamicTags2.length) this.$util.Notifi('请先勾选','error','fa-exclamation-circle')
                this.centerDialogVisible1 = false
            }
        },
         // 动态时间限制
        hiddenrading(){
            if(this.list.validPeriod == '2') return this.$util.Notifi('选择动态时间需要设置试卷开放时间，且时间的最大间隔为24个小时','error','fa-exclamation-circle')
            if(this.list.validPeriod == '1' && this.timeDt) return this.$util.Notifi('考试结束时间应该大于考试开始时间，您的设置不对， 请重新设置','error','fa-exclamation-circle')
        },
          classSelect1(value){
            if(value){
            this.list.showFromTime = this.value1[0]
            this.list.showUntilTime = this.value1[1]
         if(new Date(this.list.showUntilTime).getTime() <= new Date(this.list.showFromTime).getTime()){
            this.timeDt = true
            }
            }else{
                this.list.showFromTime = ''
            this.list.showUntilTime = ''
            this.value1 = []
             this.timeDt = false
            }
        },
              // 获取评分列表
        getCommentsList(){
            getemuComments({id:this.$route.query.threeId})
            .then(res =>{
                if(res.data.length){
                if(this.list.commentSet == '1'){
                    this.commentList = res.data
                }else{
                    this.isAmdh = false
                    this.resultList = res.data
                    let arr = []
                    for (let key in res.data) {
                        arr.push(res.data[key].segment)
                    }
                    this.outShow(arr)
                }
                }
            })
        },
              // slider回显
        outShow(ranges){
            var result = [];  
                        // 遍历每个范围字符串  
            for (var i = 0; i < ranges.length; i++) {  
            // 拆分字符串以获取最小值和最大值  
            var minMax = ranges[i].split('-');  
            
            // 提取最小值和最大值作为字符串并将其转换为数字  
            var minValue = parseInt(minMax[0], 10);  
            var maxValue = parseInt(minMax[1], 10);  
            
            // 计算范围中的最大值并将结果添加到结果数组中 
            if(maxValue !=100){
                 result.push(maxValue);  
            } 
            }  
            this.slideClik = result
            // console.log(result);
        },
    splitArray(numbers) {  
   const result = [];  
  let startValue = 0;  
  let endValue = 0;  
  const length = numbers.length;  
    
  // 处理只有一个元素的情况  
  if (length === 1) {  
    result.push(startValue + '-' + numbers[0]);  
      result.push(parseInt(Number(numbers[0]) + 1) + '-' + 100);  
    return result;  
  }  
    
  for (let i = 0; i < length; i++) {  
    const num = numbers[i];  
      
    // 处理第一个元素  
    if (i === 0) {  
      startValue = 0;  
      endValue = num;  
      result.push(startValue + '-' + endValue);  
    } else if (num > endValue) {  
      startValue = endValue;  
      endValue = num;  
      result.push(parseInt(Number(startValue) + 1) + '-' + endValue);  
    } else if (num === endValue) {  
      result.push(parseInt(Number(startValue) + 1) + '-' + endValue);  
      if (i === length - 1) {  
        endValue = 100;  
        result.push(parseInt(Number(startValue) + 1) + '-' + endValue);  
      }  
    } else {  
      result[result.length - 1] += ' ' + num;  
    }  
  }  
    
  // 添加最后一个范围，如果有必要的话  
  if (endValue < 100) {  
    result.push(parseInt(Number(endValue) + 1) + '-' + 100);  
  } 
    
  return result;  
},
               // 点击插入数字
        insertNum(){
            this.isAmdh = false
            this.slideClik.push(this.boxWidthPercent)
            this.slideClik.sort((a, b) => a - b);  
            const result = this.splitArray(this.slideClik);  
            let arr = []
            for (let key in result) {
                arr.push(
                    {
                     segment: result[key],
                     comments:''
                    }
                )
            }
           this.resultList = arr

        },
                 // 取消插入
        cacelInser(data,index,type){
            let fidd
            type ? fidd = this.slideClik[index-1] : fidd = data
            let array = this.slideClik.filter(item => item !== fidd);
            this.slideClik = array
            let result = []
            if(this.slideClik.length){
              this.slideClik.sort((a, b) => a - b);  
             result = this.splitArray(this.slideClik);  
            }else{
                result = ['0-100']
            }
            console.log(result)
            let arr = []
            for (let key in result) {
                arr.push(
                    {
                     segment: result[key],
                     comments:''
                    }
                )
            }
           this.resultList = arr
        },
        // 获取滚动条宽度
        showWidth(event){
            // 防抖
         this.isAmdh = true
        this.width = event.offsetX;  
        },
              emitFunpage(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.checkAll1 = []
        this.getopicPage(this.swichId,this.swichIndex)
      },
                    // 子组件触发的方法
        emitFun(val,i,name){
        this.commentList[i].comments = val
        },
           // 子组件触发的方法
        emitFun1(val,i,name){
        this.resultList[i].comments = val
        },
        // input输入正则
                numValid(inputContent) {
   var reg = /^([1-9]\d{0,2})$/;
   if(reg.test(this.list[inputContent])==false){
        this.list[inputContent] = "";
        return false;
   }else{
       this.list[inputContent] = this.list[inputContent];
   }
 },
         // 获取防真试卷详情
          getPaperDetail(){
            EmuPaperDetail({id:this.$route.query.threeId},'get')
            .then(res =>{
              this.list = res.data
                if(!this.list.practiceMode) this.list.practiceMode = '0' 
                if(!this.list.validPeriod) this.list.validPeriod = '2'
                 if(!this.list.answerNumType) this.list.answerNumType = '0'
                  if(!this.list.authentication) this.list.authentication = '1'
                  if(!this.list.passmark) this.list.passmark = '60'
                  if(!this.list.assessAlert) this.list.assessAlert = '1'
                  if(!this.list.scoreAlert) this.list.scoreAlert = '1'
                  this.getCommentsList()
                   if(this.list.validPeriod == '1'){
                if(res.data.showFromTime){
                    this.value1 = [res.data.showFromTime,res.data.showUntilTime]
                }else{
                    this.value1 = []
                }
                
              }
            })
            .catch(err =>{})
        },
    // 完成
    SavePush(){
                if(!this.list.validPeriod) return this.$util.Notifi('请选择试卷有效期限','error','fa-exclamation-circle')
                if(!this.list.answerNumType) return this.$util.Notifi('请选择答卷次数类型','error','fa-exclamation-circle')
                if(!this.list.practiceMode) return this.$util.Notifi('请选择练习设置','error','fa-exclamation-circle')
                if(!this.list.answerTimeControl) return this.$util.Notifi('请选择答题时间','error','fa-exclamation-circle')
                   if(!this.list.authentication) return this.$util.Notifi('请选择登录考试方式','error','fa-exclamation-circle')
              if(this.checked || this.checked1){
                if(this.checked){
               if(!this.dynamicTags1.length) return this.$util.Notifi('请选择指定组','error','fa-exclamation-circle')
                }else if(this.checked1){
             if(!this.dynamicTags2.length) return this.$util.Notifi('请选择指定考生','error','fa-exclamation-circle')
            }
              }else{
                return this.$util.Notifi('请选择指定组或指定考生考试','error','fa-exclamation-circle')
              }
              if(!this.checked){
                this.dynamicTags1 = []
              }
              if(!this.checked1){
                this.dynamicTags2 = []
              }
                if(this.list.answerTimeControl == 2){
                if(this.list.validPeriod == 2){
                 return this.$util.Notifi('选择动态时间需要设置试卷开放时间，且时间的最大间隔为24个小时，请重新设置试卷有效期限','error','fa-exclamation-circle')
                }
              }
              // 讲考生组与指定考生合并成一个数组
            let mergedArray = [...this.dynamicTags1.map(item => ({allocateId:(item.businessId || item.id == 1 ? item.id : item.allocateId), type: 1})), ...this.dynamicTags2.map(item => ({allocateId:item.businessId ? item.id : item.allocateId, type: 2}))]; 
            this.list.allocateList = mergedArray
                if(!this.list.commentSet) return this.$util.Notifi('请选择评语设置','error','fa-exclamation-circle')
                if(this.list.state){
                    delete this.list.state; 
                 }
                  if(this.list.commentSet == '1'){
                    this.list.commentList = this.commentList
                }else{
                    this.list.commentList = this.resultList
                }
                 this.loading = true
                 editEmuPaper({...this.list,id:this.$route.query.threeId},'put')
                  .then(res =>{
            this.loading = false
            if(res.code == 0){
                 this.$util.Notifi('保存成功','success','fa-check')
                     setTimeout(() => {this.$router.push('/teacheManage/enSimulationPaper')}, 100);
            }else{
               this.$util.Notifi(res.msg,'error','fa-exclamation-circle') 
            }
         })
         .catch(err =>{
            this.loading = false
            this.$util.Notifi('修改失败','error','fa-exclamation-circle')
         })
    },
          // 返回
    reback(){
        this.$router.push({
            name:'twoEnRaso',
            query:{
                twoId:this.$route.query.threeId
            }
            })
    },
    },
}
</script>
<style lang="scss" scoped>
.setting-content{
    padding: 24px 16px;
    .list-box{
        .settings-box{
            margin-bottom: 48px;
            .settings-box-tips{
                margin-bottom: 20px;
                .red-div{
                    width: 4px;
                    height: 15px;
                    background-color: #409eff;
                    margin-right: 5px;
                }
                .red-div-p{
                 font-size: 16px;
                letter-spacing: 0px;
                color: #333333!important;
                height: unset;
                font-weight: 700;
                }
            }
        }
        .field-group{
           .form-field-title{
            text-align: left;
            width: 68px;
            margin-top: 0;
            height: 15px;
            font-size: 14px;
            font-weight: normal;
            color: #333333;
            margin-left: 13px;
           }
           .form-check{
            margin-left: 20px;
           }
        }
        .form-group{
            .slider-comments{
                width: 647px;
                padding: 0px 50px 20px 40px;
             .slider-wrap{
                 position: relative;
                 padding: 30px 0 10px 5px;
                 .score-slider{
                    background-color: #e4e6e9;
                    border: 1px solid #e4e6e9;
                    height: 4px;
                    border-radius: 4px !important;
                    position: relative;
                    cursor: pointer;
                    span{
                        position: absolute;
                        display: inline-block;
                        line-height: 1px;
                        font-weight: bold;
                        color: #42ca8e;
                        min-width: 20px;
                    }
                    .min{
                         left: -30px;
                        text-align: right;
                    }
                    .max{
                    right: -35px;
                    text-align: left;
                    }
                 }
                 .handle-hint {
                    position: absolute;
                        z-index: 20;
                        display: block;
                        width: 14px;
                        height: 14px;
                        margin-left: -7px;
                        background-color: #009ee7;
                        border-radius: 14px !important;
                        top: 25px;
                        cursor: pointer;
                 }
                 .handle-hint:hover{
                    display: block !important;
                 }
                  .handle-hint::before{
                        content: attr(data-title);
                        display: inline-block;
                        text-align: center;
                        margin-top: 20px;
                        min-width: 100px;
                        margin-left: -43px;
                        font-size: 13px;
                        white-space: nowrap;
                        color: #009ee7;
                  }
                  .handle-hint::after{
                        display: inline-block;
                            font: normal normal normal 14px/1 FontAwesome;
                            font-size: inherit;
                            text-rendering: auto;
                            -webkit-font-smoothing: antialiased;
                            -moz-osx-font-smoothing: grayscale;
                            content: '\f063';
                            color: #009ee7;
                            position: absolute;
                            top: -40px;
                            animation: myAnimation 2s cubic-bezier(0.3, 2.4, 0.85, 2.5) infinite;
                  }
                  .slider-handle{
                    position: absolute;
                    display: block;
                    cursor: pointer;
                    background-color: #55cf99;
                    width: 14px;
                    height: 14px;
                    top: 25px;
                    margin-left: -7px;
                    border-radius: 14px !important;
                    transition: all 0.15s ease-in-out;
                    z-index: 10;
                  }
                  .slider-handle::after{
                    content: attr(data-value);
                    width: 30px;
                    height: 30px;
                    line-height: 30px;
                    position: absolute;
                    top: -40px;
                    left: -8px;
                    display: block;
                    background-color: #42ca8e;
                    text-align: center;
                    color: #fff;
                    border-radius: 30px;
                  }
                  .slider-handle::before{
                        content: ' ';
                        width: 0;
                        height: 0;
                        display: block;
                        border-left: 11px solid transparent;
                        border-right: 11px solid transparent;
                        border-top: 11px solid #42ca8e;
                        position: absolute;
                        left: -4px;
                        top: -15px;
                        z-index: 11;
                  }
             }   
            }
        }
         .notify-hint{
            margin-left: 10px;
            font-size: 13px;
            color: #999;
         }
         .notify-label{
            width: 90px;
            font-size: 14px;
            color: #333;
         }
         .settings-box-radio1{
            margin-bottom: 20px;
         }
         .settings-box-check{
            padding-left: 25px;
            padding-top: 10px;
            .tagsinput{
            width: 80% !important;
            min-height: 56px;
            max-height: unset;
            height: 56px;
            padding: 0px 12px 0 12px;
            background-color: #ffffff;
            border-radius: 4px!important;
            border: solid 1px #e6e6e6!important;
            overflow-y: auto;
            line-height: 27px;
            margin: 10px 25px;
            .classItem{
                padding-top: 12px;
                .el-tag{
                    margin-right: 10px;
                }
            }
            }
            .select-stu{
                margin-left: 25px;
                background-color: #36aafd;
                color: white;
                border: 1px solid #36aafd;
                padding: 7px 0px;
                border-radius: 4px!important;
                width: 122px;
                cursor: pointer;
                text-align: center;
            }
         }
        .settings-box-radio{
            padding-left: 12px;
            position: relative;
            .hiddenrading{
                position: absolute;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                z-index: 999;
                cursor: pointer;
            }
            .botRadio{
                margin-bottom: 10px;
            }
            .default-guidelines{
                border-radius: 10px !important;
                border: solid 1px #36aafd;
                padding: 20px 28px;
                margin: 20px 0;
                max-width: 400px;
                p:nth-of-type(-n+4){
                 margin-bottom: 16px;
                }
                       .span1{
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 27px;
                    letter-spacing: 0px;
                    color: #666666;
                 }
                 .span2{
                    height: 17px;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 27px;
                letter-spacing: 0px;
                color: #333333;
                 }
                             .span3{
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #999999;
                 }
            }
            .set-exam-time{
                margin-left: 19px;
                font-weight: 400;
            }
            .hint{
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #999999;
                margin-left: 10px;
            }
        }
    }
}
        @keyframes myAnimation{
            0%{
                transform: translateY(15px) scaleY(0.98);
            }
            80%{
                transform: translateY(12px) scaleY(1.02);
            }
            100%{
                transform: translateY(15px) scaleY(0.98);
            }
        }
::v-deep{
    .el-slider{
        width: 647px;
    }
    .settings-box-radio{
        .editor{
            height: 200px;
        }
    }
    .el-radio-group{
        .el-radio{
            display: block;
            margin-bottom: 20px;
        }
    }
.el-checkbox-group{
    .el-checkbox{
        margin-bottom: 20px;
        display: block;
    }
}
.setting-default-input{
     width: 80px;
    padding-left: 3px;
    .el-input__inner{
        width: 80px!important;
        height: 32px!important;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #e6e6e6;
        
    }
    .el-input__icon{
        line-height: 32px !important;
    }
}
   .is-checked{

    .el-radio__label,.el-checkbox__label{
    position: relative;
    padding-left: 5px;
    color: #333;
    font-weight: 400;
    }
.el-checkbox__label{
    padding-left: 10px;
}
   } 
   .el-checkbox__label{
    span{
        font-size: 14px;
        color: #999;
    }
   }
    .el-radio__label{
font-weight: 400;
    }
     .forminfo{
        .form-check{
            padding: 20px 50px;
        }
        .el-checkbox-group{
            .el-checkbox{
                display: flex !important;
                align-items: center !important; 
            }
        }
        .jstree-icon{
             display: block;
            width: 24px;
            height: 24px;
            
            background: url('../../../assets/images/tree-default.svg') no-repeat 0 0;
        }
        .jstree-name{
            padding-left: 5px;
        }
    }
    .checkPaper{
    .f-h-flex2{
        height: 700px;
        display: flex;
        .categories-tree{
            height: inherit;
            width: 208px;
            overflow-y: auto;
            .tree-search{
                width: 90%;
                margin: 0 auto;
                position: relative;
                span{
                    position: absolute;
                    top: 50%;
                    right: 14px;
                    transform: translateY(-50%);
                    color: #999;
                }
            }
            .categories-tree-item{
                position: relative;
                padding: 0 10px;
               .jstree-node:first-of-type{
                margin-top: 30px;
               }
               .treeactive{
                background: #f5fbff!important;
                border-radius: 4px;
               }
                .jstree-node{
                    cursor: pointer;
                    margin-top: 10px;
                    padding-left: 30px;
                    height: 24px;
                    .jstree-icon{
                        display: block;
                       width: 24px;
                        height: 24px;
                        line-height: 24px; 
                        background: url('../../../assets/images/tree-default.svg') no-repeat center;
                    }
                    span{
                        padding-left: 12px;
                    }
                }

            }
        }
        .categories-panel-dragger{
            position: relative;
            flex-shrink: 0;
            width: 16px;
            height: 100% !important;
            border-right: 1px solid #e6e6e6;
            background-color: #f2f2f2!important;
        }
        .questions-panel{
            height: 100%;
            padding: 16px 0 0 0;
            position: relative;
            .grow-top{
                height: 50px;
                line-height: 50px;
                box-shadow: 0px 3px 6px 0px rgba(51, 51, 51, 0.1);
                margin-bottom: 16px;
                position: absolute;
                width: 100%;
                top: 0;
                left: 0;
                .fillter{
                  padding: 0 20px;
                  .regulaOption{
                    width: 120px;
                  }
                }
            }
            .grow-cen-item{
                width: 100%;
                position: absolute;
                top: 60px;
                left: 0;
                height: calc(100% - 140px);
                overflow-y: auto;
                padding-left: 20px;
            }
             /*滚动条样式*/
        .grow-cen-item::-webkit-scrollbar,.categories-tree::-webkit-scrollbar{
            width: 4px;    
        }
        .grow-cen-item::-webkit-scrollbar-thumb,.categories-tree::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            background: rgba(0,0,0,0.2);
        }
        .grow-cen-item::-webkit-scrollbar-track,.categories-tree::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            border-radius: 0;
            background: rgba(255,255,255,0.1);

        }
            .grow-bot{
                position: absolute;
                width: 100%;
                bottom: 15px;
                left: 0;
                box-sizing: border-box;
                justify-content: space-between;
                width: 100%;
                padding: 0 16px;
                height: 50px;
                line-height: 50px;
                box-shadow: 3px -1px 6px 0px rgba(51, 51, 51, 0.1);
                .grow-bot-btn{
                    margin-top: 10px;
                    height: 32px;
                    line-height: 30px;
                    font-size: 14px;
                    padding: 0 16px;
                    border-radius: 2px;
                    font-family: inherit;
                    border-width: 1px;
                    border-style: solid;
                    text-align: center;
                    vertical-align: middle;
                    box-sizing: border-box;
                    cursor: pointer;
                    transition: all 0.3s;
                    background: #155bd4;
                    color: #fff;
                }
            }
        }
    }
    .tab-content{
        h4{
            font-size: 14px;
            font-weight: 400;
        }
        .qts-counts-tip{
            margin-top: 10px;
            .question-count{
                b{
                    color: #FF962A;
                }
            }
        }
        .at-sel-qs-cs-ls{
            margin: 24px 0 16px;
            .at-sel-qs-cs-ls-item{
                margin-bottom: 10px;
              .icon-delet{
                position: unset!important;
                font-size: 14px;
                margin-top: 0;
                margin-right: 12px;
                vertical-align: middle;
                cursor: pointer;
                color: #999;
              }
              .qts-cate-name{
                    min-width: 215px;
                cursor: pointer;
              }  
              .form-control{
                font-size: 14px;
                font-weight: normal;
                color: #333;
                background-color: #fff;
                border: 1px solid #e5e5e5;
                box-shadow: none;
                text-align: center;
                line-height: 1.5;
                padding: 5px 10px;
                border-radius: 3px;
                margin: 0 10px;
              }
            }
            .icon-folder{
                display: inline-block;
                text-align: center;
                margin-right: 0;
                background: url('../../../assets/images/tree-default.svg') no-repeat center;
                    position: unset!important;
                    width: 20px!important;
                    height: 20px;
                    margin-top: 0;
                    vertical-align: middle;
                    cursor: pointer;
            }
        }
    }
    .no-category{
        text-align: center;
        padding: 50px 0;
        img{
            width: 120px;
        }
        .text{
           margin-bottom: 20px;
            width: 266px;
            text-align: center; 
            margin: 0 auto;
            font-size: 14px;
            span{
                color: #36aafd;
            }
        }
        .yks-blue{
            background-color: #155bd4;
            color: white;
            border: 1px solid #155bd4;
            padding: 7px 20px;
            border-radius: 4px!important;
            width: 100px;
            margin: 20px auto;
            cursor: pointer;
        }
    }
}
   .grow-cen-item{
        .topEditBtn{
            i{
                color: #999;
                padding-left: 20px;
                cursor: pointer;
            }
        }
        .el-checkbox-group{
                    .el-checkbox:hover{
            border: 1px solid #36aafd;
        }
        .commonClass{
            border: dashed 1px #eb0000!important;
            background-color:#fffafa!important
        }
       .el-checkbox{
            display: flex;
            padding: 24px 16px 20px;
            background-color: #ffffff;
            border-radius: 5px;
            border: solid 1px #e6e6e6;
            position: relative;
            margin-top: 16px;
            .el-checkbox__input{
                padding-top: 5px;
            }
            .el-checkbox__label{
                flex-grow: 1;
            }
            .topic-item{
                .question-option-list{
                padding: 0 20px;
                margin-top: 30px;
                li{
                    list-style-type: upper-latin;
                    margin-bottom: 15px;
                    font-size: 14px;
                }
                li::marker{
                    unicode-bidi: isolate;
                font-variant-numeric: tabular-nums;
                text-transform: none;
                text-indent: 0px !important;
                text-align: start !important;
                text-align-last: start !important; 
                }
                .test_result{
                    margin-left: -20px;
                    .rightAnswer{
                        color: #36aafd;
                    }
                    .jx{
                        color: #999;
                        padding-top: 10px;
                    }
                }
            }
                .ques-title{
                    width: 100%;
                 .ques-number{
                    background-color: white;
                    color: #36aafd;
                    margin-right: 8px;
                    padding: 0px 12px;
                    border-radius: 4px!important;
                    font-size: 14px;
                    border: 1px solid #36aafd;
                 }
                 .ques-type{
                    background-color: #36aafd;
                    padding: 2px 12px;
                    color: #fff;
                    border: none;
                    border-radius: 4px!important;
                    font-size: 12px;
                    margin-right: 20px;
                 }   
                }
                .ques-answers{
                    padding-top: 15px;
                    .ques-answers-class{
                        height: 40px;
                        .label{
                            color: #999;
                            font-size: 14px;
                        }
                        .labels{
                            height: initial;
                            line-height: initial;
                            padding: 2px 12px;
                            font-size: 12px;
                            color: #999!important;
                            border-radius: 5px;
                            border: solid 1px #e6e6e6;
                            background-color: transparent!important;
                        }
                    }
                    .ques-answers-edit{
                        padding-top: 10px;
                        .edit-question{
                            padding: 0!important;
                        margin-right: 10px;
                        color: #4e6799;
                        cursor: pointer;
                        font-size: 14px;
                        }
                        .control-line{
                            display: inline-block;
                        vertical-align: middle;
                        width: 1px;
                        height: 16px;
                        background-color: #e6e6e6;
                        margin-right: 10px;
                        }
                    }
                }
            }
        }
        .el-checkbox:last-of-type{
            margin-right: 30px;
        } 
        }

    }
}
</style>